var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useDataTrackingPush } from './useDataTrackingPush';
export var useFirebasePush = function (data, logger, timeoutConfig) {
    if (logger === void 0) { logger = console; }
    if (timeoutConfig === void 0) { timeoutConfig = {}; }
    logger.warn('[Warning - useFirebasePush] This is deprecated (soon will be removed), please use useDataTrackingPush() instead');
    return useDataTrackingPush(__assign(__assign({}, data), { type: 'FIREBASE' }), logger, timeoutConfig);
};
